import { useMutation, useQueryClient } from '@tanstack/react-query';
import { screeningTestsApi } from '../../../apis';
import { InternalApiScreeningFlowTest } from '../../../api-internal';

export const useCreateScreeningTestForDraft = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ draftId, body }: { draftId: number; body: InternalApiScreeningFlowTest }) =>
      screeningTestsApi.createScreeningTestForDraft({ draftId, internalApiScreeningFlowTest: body }),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['flowDrafts'] }),
        queryClient.invalidateQueries({ queryKey: ['organisationFlowDrafts'] }),
      ]);
    },
  });
};
